import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, Clock, CheckCircle2, ArrowUpRight } from "lucide-react";
import { courseStats, LEVEL_STYLES } from "../../lib/learning";

export default function CourseCard({ course, prog, index = 0 }) {
  const s = courseStats(course, prog);
  return (
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.08 }} whileHover={{ y: -6 }}>
      <Link to={`/learn/${course.slug}`} data-testid={`course-card-${course.slug}`}
        className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-shadow duration-300 hover:shadow-2xl">
        <div className="relative aspect-[16/10] overflow-hidden bg-navy">
          {course.cover_image && <img src={course.cover_image} alt={course.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
          <span className={`absolute left-4 top-4 rounded-full px-3 py-1 text-xs font-bold ${LEVEL_STYLES[course.level]}`}>{course.level}</span>
          {s.completed && <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-mint px-3 py-1 text-xs font-bold text-navy" data-testid={`course-completed-${course.slug}`}><CheckCircle2 size={13} /> Completed</span>}
        </div>
        <div className="flex flex-1 flex-col p-7">
          <p className="text-xs font-semibold uppercase tracking-wider text-gold-600">{course.category}</p>
          <h3 className="mt-2 text-xl font-bold text-navy">{course.title}</h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{course.summary}</p>
          <div className="mt-5 flex items-center gap-5 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1.5"><BookOpen size={14} /> {course.lesson_count} lessons</span>
            <span className="inline-flex items-center gap-1.5"><Clock size={14} /> {course.total_minutes} min</span>
          </div>
          {prog ? (
            <div className="mt-5">
              <div className="h-1.5 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-mint transition-[width] duration-500" style={{ width: `${s.pct}%` }} /></div>
              <p className="mt-2 text-xs font-semibold text-navy" data-testid={`course-progress-${course.slug}`}>{s.pct}% complete</p>
            </div>
          ) : (
            <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-navy">Start course <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5" /></span>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
